// ABOUTME: RTK Query endpoints for relationnews - warehouse-authored news messages for relations.
// ABOUTME: Management CRUD/publish plus the relation-facing archive, popup feed and mark-seen endpoints.

import { apiSlice } from "../createApiSlice";

const ApiName = "RelationNews";
const buildUrl = (endpoint) => `/relationnews${endpoint}`;

export const relationNewsSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getRelationNewsList: builder.query({
            query: (params) => ({
                url: buildUrl(params?.state ? `?state=${params.state}` : ""),
                method: 'GET',
            }),
            providesTags: [{ type: ApiName }],
        }),
        getRelationNews: builder.query({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            providesTags: [{ type: `${ApiName}Single` }],
        }),
        addRelationNews: builder.mutation({
            query: (body) => ({
                url: buildUrl(``),
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: ApiName }, { type: `${ApiName}Single` }, { type: `${ApiName}Archive` }],
        }),
        updateRelationNews: builder.mutation({
            query: ({ id, ...body }) => ({
                url: buildUrl(`/${id}`),
                method: 'PUT',
                body,
            }),
            invalidatesTags: [{ type: ApiName }, { type: `${ApiName}Single` }, { type: `${ApiName}Archive` }],
        }),
        publishRelationNews: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}/publish`),
                method: 'POST',
            }),
            invalidatesTags: [{ type: ApiName }, { type: `${ApiName}Single` }, { type: `${ApiName}Archive` }],
        }),
        unpublishRelationNews: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}/unpublish`),
                method: 'POST',
            }),
            invalidatesTags: [{ type: ApiName }, { type: `${ApiName}Single` }, { type: `${ApiName}Archive` }],
        }),
        deleteRelationNews: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: ApiName }, { type: `${ApiName}Single` }, { type: `${ApiName}Archive` }],
        }),
        getRelationNewsArchive: builder.query({
            query: ({ page = 1, size = 20 } = {}) => ({
                url: buildUrl(`/archive?page=${page}&size=${size}`),
                method: 'GET',
            }),
            providesTags: [{ type: `${ApiName}Archive` }],
        }),
        getRelationNewsFeed: builder.query({
            query: () => ({
                url: buildUrl(`/feed`),
                method: 'GET',
            }),
        }),
        markRelationNewsSeen: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}/seen`),
                method: 'POST',
            }),
            invalidatesTags: [{ type: `${ApiName}Archive` }],
        }),
    })
});

export const {
    useGetRelationNewsListQuery,
    useGetRelationNewsQuery,
    useAddRelationNewsMutation,
    useUpdateRelationNewsMutation,
    usePublishRelationNewsMutation,
    useUnpublishRelationNewsMutation,
    useDeleteRelationNewsMutation,
    useGetRelationNewsArchiveQuery,
    useGetRelationNewsFeedQuery,
    useMarkRelationNewsSeenMutation,
} = relationNewsSlice;
